export default
{
    name: 'app-page',

    watch:
    {
        ready: 'onReadyChange'
    },

    props:
    {
        contentPage: { type: null, default: null}
    },

    data()
    {
        return {
            ready: false
        }
    },

    created()
    {
        document.body.scrollTop = 0

        this.meta = this.$route.meta
    },

    mounted()
    {
        this.ready = true
    },

    methods:
    {
        // WATCHERS
        onReadyChange()
        {
            if (this.ready)
            {
                this.eventHub.$emit('page:ready', this.ready)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/mixins/app-page/index.js